export enum DeviceResourceRecipeType {
  Bootstrap,
  BootstrapPostcard,
  BootstrapCDMOnlyPostcard,
  Prefetch,
  CDM,
  LEDM,
  ProductNumber
}
